import { createApiDescription } from "../../helperFunctions";

export const loginApiInfo = {
    login: createApiDescription(
        "This API can be called to Login and create authentication token to access all the APIs in different products.",
        [
            "Login API supports only for users who got created through company’s account management and cannot be used for Office 365 users."
        ]
    ),
    refreshToken: createApiDescription(
        "This API can be called to refresh the current session of the user by generating new authentication token without providing username & password every time and accessing login API.",
        [
            "You must pass the login token from the Login API.",
            "Response will include number of minutes the login token will remain active before you need to refresh again."
        ]
    )
}